<!--
~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
-->

<ngf-dialog-title mat-dialog-title>
  {{ data.title }}
</ngf-dialog-title>

<mat-dialog-content>
  <div class="modal-message">
    @if (data?.messageAsHtml) {
      <span [innerHTML]="data.message"></span>
    }
    @if (!data?.messageAsHtml) {
      <span>{{ data.message }}</span>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button ngfButton="primary" mat-dialog-close>OK</button>
</mat-dialog-actions>
